module.exports = __webpack_public_path__ + "static/media/failed_order_delivery.2b3d4665.svg";